<template>
  <div class="bg-0D1225 py-5 position-relative overflow-hidden">
    <div class="text-center mb-5" style="max-width: 85%; margin: auto;">
      <h2 class="mb-2 custom-54px-600 text-center p-2 font-Inter font-weight-bold text-white">Feedback</h2>
      <p class="custom-18px-400 text-center p-2 font-Inter text-white">
        Discover the Success Stories of Those We've Helped
      </p>
    </div>

    <div class="scroll-wrapper">
      <div class="scroll-track">
        <div
          v-for="(item, index) in repeatedTestimonials"
          :key="index"
          class="testimonial-card"
          :style="{ width: item.width + 'px' }"
        >
          <p class="mb-3">{{ item.message }}</p>
          <div class="d-flex align-items-center mt-3">
            <img
              :src="item.avatar"
              class="rounded-circle mr-2"
              width="32"
              height="32"
            />
            <div>
              <strong class="text-white">{{ item.name }}</strong><br />
              <small class="text-white-50">Parents</small>
            </div>
          </div>
        </div>
      </div>
      <div class="center-gradient-overlay"></div>
    </div>
  </div>
</template>

<script>
function randomWidth(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export default {
  name: "RandomWidthTestimonialScroll",
  data() {
    return {
      baseTestimonials: [
        {
          message: "Alhamdulillah. Terima kasih Ustaz Abi...",
          name: "Insyirah Nuusyrah",
          avatar: require("@/assets/img/Avatar/Woman/1.png"),
        },
        {
          message: "Anak saya Nur Chinta Elfiera berjaya dapat 8A...",
          name: "Haslizawati Md Akhir",
          avatar: require("@/assets/img/Avatar/Woman/2.png"),
        },
        {
          message: "Alhamdulillah syukur kepada Allah...",
          name: "Tie Suha",
          avatar: require("@/assets/img/Avatar/Woman/2.png"),
        },
        {
          message: "FlyHigh sangat membantu anak saya capai 8A!",
          name: "Zulaikha",
          avatar: require("@/assets/img/Avatar/Woman/1.png"),
        },
        {
          message: "Tq FlyHigh berkongsi ilmu dan tips menarik...",
          name: "Nur Rinie Mohamad Noor",
          avatar: require("@/assets/img/Avatar/Woman/1.png"),
        },
        {
          message: "FlyHigh sangat membantu anak saya capai 8A!",
          name: "Zulaikha",
          avatar: require("@/assets/img/Avatar/Woman/1.png"),
        },
        {
          message: "Tq FlyHigh berkongsi ilmu dan tips menarik...",
          name: "Nur Rinie Mohamad Noor",
          avatar: require("@/assets/img/Avatar/Woman/1.png"),
        },
        {
          message: "FlyHigh sangat membantu anak saya capai 8A!",
          name: "Zulaikha",
          avatar: require("@/assets/img/Avatar/Woman/1.png"),
        },
        {
          message: "Tq FlyHigh berkongsi ilmu dan tips menarik...",
          name: "Nur Rinie Mohamad Noor",
          avatar: require("@/assets/img/Avatar/Woman/1.png"),
        },
      ],
    };
  },
  computed: {
    repeatedTestimonials() {
      const all = [...this.baseTestimonials, ...this.baseTestimonials];
      return all.map((t) => ({
        ...t,
        width: randomWidth(240, 360),
      }));
    },
  },
};
</script>

<style scoped>
.scroll-wrapper {
  overflow: hidden;
  width: 100%;
  padding-left: 3%;
  position: relative;
}

.scroll-track {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: center;
  max-height: 440px;
  animation: scroll-horizontal 80s linear infinite;
  align-content: baseline;
}

.testimonial-card {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 16px;
  padding: 20px;
  color: white;
  flex-shrink: 0;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.testimonial-card:hover {
  transform: scale(1.05);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
  z-index: 2;
  cursor: pointer;
}

/* Animasi scroll kiri ke kanan tak terbatas */
@keyframes scroll-horizontal {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-50%);
  }
}

/* Spotlight Gradasi Tengah */
.center-gradient-overlay {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 50%;
  height: 100%;
  background: radial-gradient(circle at center, rgba(255, 255, 255, 0.05), transparent 70%);
  pointer-events: none;
  z-index: 2;
}
</style>
